module.exports = __webpack_public_path__ + "img/WM_licensefront.e1f22dd6.png";